import { PageHero } from "../components/site/PageHero";
import { Reveal } from "../components/site/Motion";
import { ApplicationForm, ROLES } from "../components/forms/ApplicationForm";

export default function Careers() {
  return (
    <main data-testid="careers-page">
      <PageHero overline="Careers" lines={["Work that", "keeps India", "running."]} testId="careers-hero">
        <div className="relative mt-12 grid gap-4 overflow-hidden sm:grid-cols-3">
          {["/img/helmet.jpg", "/img/housekeeping.jpg", "/img/warehousing.jpg"].map((src, i) => (
            <div key={src} className={`clip-notch-sm aspect-[4/3] overflow-hidden ${i > 0 ? "hidden sm:block" : ""}`}>
              <img src={src} alt="BHISM team at work" className="h-full w-full object-cover grayscale transition-[filter,transform] duration-700 hover:scale-105 hover:grayscale-0" />
            </div>
          ))}
        </div>
      </PageHero>
      <section className="bg-[var(--ink)] pb-28">
        <div className="mx-auto grid max-w-[1440px] gap-16 px-5 md:px-10 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <p className="text-lg text-[var(--bone-2)]">
              We regularly hire across housekeeping, technical, back-office and logistics roles. Apply once — we will match you to openings at client sites.
            </p>
            <p className="mt-10 overline text-[var(--signal)]">Roles we hire for</p>
            <ul className="mt-4 flex flex-wrap gap-2" data-testid="careers-roles">
              {ROLES.filter((r) => r !== "Other").map((r) => (
                <li key={r} className="rounded-full border border-white/20 px-3 py-1.5 text-sm text-[var(--bone)]">{r}</li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-7 lg:col-start-6">
            <ApplicationForm />
          </Reveal>
        </div>
      </section>
    </main>
  );
}
